import Vue from 'vue';
import App from './App.vue';
// 导入Bootstrap CSS
import 'bootstrap/dist/css/bootstrap.min.css';
// 导入Bootstrap JS
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
// 导入Bootstrap图标
import 'bootstrap-icons/font/bootstrap-icons.css';

// 添加全局动画样式
const globalStyles = `
    .fade-enter-active, .fade-leave-active {
        transition: opacity 0.5s ease;
    }
    .fade-enter, .fade-leave-to {
        opacity: 0;
    }
    
    .slide-up-enter-active, .slide-up-leave-active {
        transition: all 0.3s ease;
    }
    .slide-up-enter, .slide-up-leave-to {
        transform: translateY(20px);
        opacity: 0;
    }
    
    .pulse {
        animation: pulse 2s infinite;
    }
    
    @keyframes pulse {
        0% { transform: scale(1); }
        50% { transform: scale(1.05); }
        100% { transform: scale(1); }
    }
    
    .hover-lift {
        transition: transform 0.3s ease;
    }
    
    .hover-lift:hover {
        transform: translateY(-2px);
    }
    
    .text-gradient {
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
    }
`;

const styleSheet = document.createElement('style');
styleSheet.textContent = globalStyles;
document.head.appendChild(styleSheet);

Vue.config.productionTip = false;

new Vue({
  render: h => h(App),
}).$mount('#app');
